import { Dispatch } from "react";
import styled from 'src/lib/styles/css';

//#region [Component]
export default function NFKHeader() {

	return <SNFKNav role="navigation">

		<SBrand href="https://www.nfkino.no/">
			{/*eslint-disable-next-line @next/next/no-img-element*/}
			<SBrandImage src="https://www.nfkino.no/themes/custom/nfbiono/logo.svg" alt="Home" />
		</SBrand>

	</SNFKNav>;
}
//#endregion



//#region [Styles]
const SNFKNav = styled.nav`
	display: flex;
	height: 96px;
	align-items: center;
	color: white;
	font-size: 17px;
	font-weight: bold;
	font-family: sans-serif !important;
	justify-content: space-between;
	padding: 0 40px;
	background-color: #0e0e1b;
`;

const SBrand = styled.a`
	margin: 0 auto;
`;

const SBrandImage = styled.img`
	height: 56px;
`



//#endregion
